import { useEffect, useRef, useState } from "react";
import styles from "./index.module.less";

interface GradientProgressProps {
  progress?: number;
  width?: number;
  height?: number;
  borderRadius?: number;
  borderWidth?: number;
  gradientColors?: string[];
  showPercentage?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export function WarpBoardProgress({
  progress = 0,
  borderWidth = 6,
  borderRadius = 20,
  gradientColors = ["#F6F4F9", "#FFDCC8", "#FF81D8", "#DA74FF"],
  showPercentage = true,
  className = "",
  children,
}: GradientProgressProps) {
  const [currentProgress, setCurrentProgress] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setCurrentProgress(progress);
    // const timer = setTimeout(() => {
    //   setCurrentProgress(progress || 0);
    // }, 500);

    // return () => clearTimeout(timer);
  }, [progress]);

  const [size, setSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    if (containerRef.current) {
      setSize({
        width: containerRef.current.offsetWidth,
        height: containerRef.current.offsetHeight,
      });
    }
  }, [progress]);

  const { width, height } = size;

  // Create gradient definition
  const gradientId = "gradientBorder";

  // 卡片周长
  const circumference =
    borderRadius * 2 * Math.PI +
    (width + height + borderWidth * 2 - (borderRadius - borderWidth / 2) * 4) *
      2;

  // When progress is 100%, ensure the offset is 0 to completely close the border
  const strokeDashoffset =
    currentProgress >= 100 ? 0 : (1 - currentProgress / 100) * circumference;

  const [hideProgress, setHideProgress] = useState(false);
  useEffect(() => {
    if (currentProgress >= 100) {
      // 延迟1秒隐藏进度条
      const timer = setTimeout(() => {
        setHideProgress(true);
      }, 1000);

      return () => {
        clearTimeout(timer);
      };
    } else {
      setHideProgress(false);
    }
  }, [currentProgress]);

  return (
    <div className={styles.wrap} ref={containerRef}>
      {size.width > 0 && size.height > 0 && !hideProgress && (
        <div
          className={styles.progress}
          style={{
            left: -borderWidth,
            top: -borderWidth,
            width: width + borderWidth * 2,
            height: height + borderWidth * 2,
            background: "#eee",
            borderRadius: borderRadius,
          }}
        >
          <svg
            width={width + borderWidth * 2}
            height={height + borderWidth * 2}
          >
            <defs>
              <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
                {/* <stop stopColor="#F6F4F9" /> */}
                <stop offset="0.263041" stopColor="#FFDCC8" />
                <stop offset="0.64245" stopColor="#FF81D8" />
                <stop offset="1" stopColor="#DA74FF" />
              </linearGradient>
            </defs>
            <rect
              x={borderWidth / 2}
              y={borderWidth / 2}
              width={width + borderWidth}
              height={height + borderWidth}
              rx={borderRadius - borderWidth / 2}
              ry={borderRadius - borderWidth / 2}
              fill="transparent"
              stroke={`url(#${gradientId})`}
              strokeWidth={borderWidth}
              strokeDasharray={circumference}
              strokeDashoffset={-strokeDashoffset}
              strokeLinecap="round"
              style={{
                transition: "stroke-dashoffset 1s ease-in-out",
              }}
            />
          </svg>
        </div>
      )}
      {children}
      {!hideProgress && (
        <div className={styles.mask}>{Math.floor(progress)}%</div>
      )}
    </div>
  );
}
